define(["require", "exports", "jquery", "knockout", "log", "../../utils/urls", "../../utils/tools", "../../utils/kendoUtils", "../../models/UserContext"], function (require, exports, $, ko, log, urls_1, tools, KendoUtils, UserContext) {
    "use strict";
    var DailyInvoices = /** @class */ (function () {
        function DailyInvoices() {
            this.gridId = "tblDailyInvoicesKendo";
            this.canExport = ko.observable(UserContext.hasAccess("Admin,Accounting.Export"));
            this.isAdmin = ko.observable(UserContext.hasAccess("Admin"));
        }
        DailyInvoices.prototype.init = function () {
            var self = this;
            $("#page-title").text("Daily Bill Items Calculations Report");
            tools.ajaxGet({
                url: "/Accounting/DailyInvoicesLookupData",
                success: function (data) {
                    if (data.Success) {
                        self.lookupLists = data.Data.lookupLists;
                    }
                    else {
                        log.error(data.Error);
                    }
                    self.initGrid();
                    ko.applyBindings(self, document.getElementById("ko-main-content"));
                    $("#contextLoader").hide();
                    $("#mainContext").show();
                }
            });
        };
        DailyInvoices.prototype.initGrid = function () {
            var _this = this;
            var self = this;
            var gridStructure = self.lookupLists.GridStructures.ActionLogsStructure;
            var columns = gridStructure.columns;
            self.mainTable = new KendoUtils.KendoUtils();
            var gridOptions = {
                dataSourceOptions: {
                    transport: {
                        read: {
                            url: "/Accounting/GetActionLogs",
                            type: "POST",
                            data: function () {
                                var data = {};
                                /*if (self.filterByAny()) {
                                    data.filterText = self.filterByAny();
                                }*/
                                return data;
                            },
                            dataType: "json"
                        }
                    },
                    schema: {
                        model: gridStructure.model
                    }
                },
                gridOptions: {
                    //toolbar: kendo.template($('#sg-toolbar-template').html()),
                    columns: columns,
                    resizable: true,
                    detailInit: self.initRecurrings.bind(self)
                },
                enableExport: {
                    entityName: "ActionLog",
                    title: "Action Logs",
                    enablePdf: false
                },
                allowBulkEdits: {
                    enabled: false
                },
                gridId: self.gridId,
                showPagerOnTop: false,
                autoHeight: {
                    totalOffset: 46 + 41 + 3
                },
            };
            self.mainTable.initGrid(gridOptions);
            $(window).resize(function () {
                _this.resize();
            });
            setTimeout(function () {
                _this.resize();
            }, 1);
        };
        DailyInvoices.prototype.initRecurrings = function (e) {
            var self = this;
            var gridStructure = self.lookupLists.GridStructures.RecurringStructure;
            var grid = $("<div/>").appendTo(e.detailCell).kendoGrid({
                dataSource: {
                    transport: {
                        read: {
                            url: "/Accounting/GetActionLogRecurrings",
                            type: "POST",
                            data: function () {
                                var data = {};
                                data.key = e.data.Key;
                                /*if (self.filterByAny()) {
                                    data.filterText = self.filterByAny();
                                }*/
                                return data;
                            },
                            dataType: "json"
                        }
                    },
                    serverPaging: false,
                    serverSorting: false,
                    serverFiltering: false,
                    pageSize: 100,
                    schema: {
                        model: gridStructure.model,
                        data: function (response) { return response.Data; },
                        total: "Total",
                        aggregates: "Aggregates",
                        errors: "Errors"
                    }
                },
                scrollable: false,
                resizable: true,
                sortable: true,
                pageable: true,
                columns: gridStructure.columns,
                dataBound: function (event) {
                }
            }).data("kendoGrid");
        };
        DailyInvoices.prototype.resize = function () {
            var self = this;
            var gridElement = $("#".concat(self.gridId)), newHeight = window.innerHeight - 75 - 41 - 45 - 100, otherElements = gridElement.children().not(".k-grid-content"), otherElementsHeight = 0;
            $("#" + self.gridId).height(newHeight);
            otherElements.each(function () {
                otherElementsHeight += $(this).outerHeight();
            });
            var contentHeight = newHeight - otherElementsHeight;
            if (contentHeight < 200) {
                contentHeight = 200;
            }
            gridElement.children(".k-grid-content").height(contentHeight);
        };
        DailyInvoices.prototype.exportTo = function () {
            var self = this;
            if (self.canExport()) {
                self.mainTable.exportTo();
            }
        };
        return DailyInvoices;
    }());
    setTimeout(function () {
        if (urls_1.urls.startsWith("/Accounting/DailyInvoices")) {
            log.log("Initialize DailyInvoices list");
            $(function () {
                (new DailyInvoices()).init();
            });
        }
    }, 0);
    return DailyInvoices;
});
//# sourceMappingURL=dailyInvoices.js.map


//////////////////
// WEBPACK FOOTER
// ./build/areas/accounting/dailyInvoices.js
// module id = 279
// module chunks = 2